module.exports = __webpack_public_path__ + "img/lunar2.df723844.jpg";